import { OnboardingBackdrop } from '@/components/onboarding/onboarding-backdrop';

/**
 * The photograph behind a module conversation, when an editor has uploaded one.
 *
 * `site_settings.chat_background` is optional, and blank is the normal case:
 * the chat then keeps its built-in per-theme backdrops (sand for kids, ocean
 * for everyone else), which is why this renders nothing rather than falling
 * back to a bundled file. `ChatModule` only mounts it when there is an asset.
 *
 * Two things make an arbitrary upload safe to put behind a conversation:
 *
 * 1. **The wash is not the editor's problem.** `.chat-ground` paints a blue
 *    scrim over the photograph that thickens toward the bottom of the
 *    viewport, which is where the newest messages and the answer footer are.
 *    A staff member uploads a photograph; the app guarantees the contrast.
 * 2. `OnboardingBackdrop` is reused rather than copied, so a Prismic asset
 *    gets the same `preload`, `decode()`-then-reveal and reserved box the
 *    onboarding and journey grounds get. It carries inlined thumbnails only
 *    for the bundled paths, so a Prismic URL simply reveals out of the ground
 *    colour instead of a blur — no layout shift either way.
 *
 * Fixed to the viewport and `aria-hidden`, entirely outside the layout: a
 * module's thread is many screens tall, and this way it scrolls over the
 * photograph rather than stretching it.
 */
export function ChatGround({ src }: { src: string }) {
  return (
    <div aria-hidden className="chat-ground">
      <OnboardingBackdrop src={src} />
    </div>
  );
}
